import {
  ChevronDoubleLeft,
  ChevronDoubleRight,
  ChevronLeft,
  ChevronRight,
} from "react-bootstrap-icons";
import PaginationButton from "./PaginationButton";

export default function Pagination({
  navigate,
  currentPage,
  totalPages,
  totalItemCount,
  itemsPerPage,
  showPageCount = false,
  showInput = false,
}: {
  navigate: (page: number) => void;
  currentPage: number;
  totalPages: number;
  totalItemCount: number;
  itemsPerPage: number;
  showPageCount?: boolean;
  showInput?: boolean;
}) {
  const starting = itemsPerPage - 1;
  const min = currentPage * itemsPerPage - starting;
  const max =
    currentPage * itemsPerPage > totalItemCount
      ? totalItemCount
      : currentPage * itemsPerPage;

  /*  allow only numbers or empty string */
  function updatePage(e: React.ChangeEvent<HTMLInputElement>) {
    e.target.blur();
    const page = Number(e.target.value);
    if (Number.isNaN(page) || page < 1 || page > totalPages) return;
    navigate(page);
  }

  return (
    <div className="d-flex align-items-center">
      <div className="me-2" style={{ fontSize: "12px" }}>
        {showPageCount ? (
          <div>
            Page {currentPage} of {totalPages}
          </div>
        ) : (
          <div>
            {min}-{max} of {totalItemCount}
          </div>
        )}
      </div>
      {showInput && (
        <input
          id="pagination-input"
          type="text"
          value={currentPage.toString()}
          onChange={updatePage}
          onFocus={(e) => e.target.select()}
          style={{
            fontSize: "12px",
            width: "61px",
            height: "24px",
            lineHeight: "24px",
          }}
          placeholder="Go To No."
          className="me-2"
        />
      )}

      <PaginationButton
        onClick={() =>
          currentPage - 10 < 1 ? navigate(1) : navigate(currentPage - 10)
        }
        disabled={currentPage === 1}
      >
        <ChevronDoubleLeft />
      </PaginationButton>
      <PaginationButton
        onClick={() => navigate(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <ChevronLeft />
      </PaginationButton>
      <PaginationButton
        onClick={() => navigate(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <ChevronRight />
      </PaginationButton>
      <PaginationButton
        onClick={() =>
          currentPage + 10 > totalPages
            ? navigate(totalPages)
            : navigate(currentPage + 10)
        }
        disabled={currentPage === totalPages}
      >
        <ChevronDoubleRight />
      </PaginationButton>
    </div>
  );
}
